import { INPUTCOL, MINCOL } from "../../../constants/const"
import ZeileLöschenAD from "../../Datenerfassung/Bearbeitung/ZeileLöschenAD";
import DeChecks from "../../Datenerfassung/DeChecks";
import CommentCellDatenerfassung from "../CommentCellDatenerfassung";
import EditableCell from "../EditableCell";
import DropdownFilter from "../SD_einsehen/DropdownFilter"
import NoFilterButUnit from "../SD_einsehen/NoFilter";

export const absdatenHeader = [
    {accessor: 'jahr',
    Header: 'Jahr',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'abschnitt',
    Header: 'Abschnitt',
    width: '12em',
    Filter: DropdownFilter},
    {accessor: 'distanz',
    Header: 'Länge (in m)',
    width: MINCOL},
    {accessor: 'vv',
    Header: 'Verkehrsvertrag',
    width: '12em',
    Filter: DropdownFilter},
    {accessor: 'zv',
    Header: 'Zweckverband',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'linie',
    Header: 'Linie',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'produkt',
    Header: 'Produkt',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'tg',
    Header: 'Tagesgruppe',
    width: MINCOL,
    Filter: DropdownFilter},
    {accessor: 'fahrtage',
    Header: 'Fahrtage pro Jahr',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'fahrtenpaare',
    Header: 'Fahrtenpaare pro Tag',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'besetzung',
    Header: 'Besetzung pro Tag',
    width: INPUTCOL,
    Cell: EditableCell,
    Filter: NoFilterButUnit},
    {accessor: 'status',
    Header: 'Status',
    Filter: DropdownFilter,
    width: MINCOL},
    {accessor: 'checked',
    Header: 'Status ändern',
    Cell: DeChecks,
    width: MINCOL},
    {accessor: 'kommentar',
    Header: 'Kommentar',
    Cell: CommentCellDatenerfassung
    },
    {accessor: 'del',
    Header: 'Löschen',
    Cell: ZeileLöschenAD
    }
];

export const hiddenColumns = ['absdatId', 'vvId', 'zvId', 'linieId', 'prodId', 'bhfId', 'tgId'];

export const absdCsvHeader = [
    {key: 'code',
    label: 'Schluessel'},
    {key: 'jahr',
    label: 'Jahr'},
    {key: 'vv',
    label: 'Verkehrsvertrag'},
    {key: 'zv',
    label: 'Zweckverband'},
    {key: 'linie',
    label: 'Linie'},
    {key: 'abschnitt',
    label: 'Abschnitt'},
    {key: 'prod',
    label: 'Produkt'},
    {key: 'richtung',
    label: 'Richtung'},
    {key: 'tg',
    label: 'Tagesgruppe'},
    {key: 'fahrtage',
    label: 'Fahrtage pro Jahr'},
    {key: 'fahrtenpaare',
    label: 'Fahrtenpaare pro Tag'},
    {key: 'besetzung',
    label: 'Besetzung pro Tag'},
    {key: 'status',
    label: 'Status'}];